import React, { useState, useRef, ChangeEvent } from 'react';
import { motion } from 'framer-motion';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AddLinkIcon from '@mui/icons-material/AddLink';

interface UrlShortenerButtonProps {}

const UrlShortenerButton = ({}: UrlShortenerButtonProps) => {
  return (
    <>
      <motion.div whileTap={{ scale: 0.9 }} whileHover={{ scale: 1.05 }}>
        <Box id="url-shortener" sx={{ marginLeft: '10px' }}>
          <Tooltip title="URL shortener" placement="top" enterDelay={1000}>
            <span>
              <IconButton
                disableRipple
                sx={{ p: 0, color: '#5a5a5a' }}
                size="small"
              >
                <AddLinkIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </motion.div>
    </>
  );
};

export default UrlShortenerButton;
